module.exports = __webpack_public_path__ + "img/slider.faebea50.jpg";